export enum SalaryType {
  PERUNIT = "за единицу",
  PERMONTH = "за месяц",
  PERDAY = "за день",
}
export interface IPricing {
  _id: string;
  for?: string;
  machineId?: string;
  forName: string;
  perUnit?: number;
  perMonth?: number;
  quantity?: number;
}

export interface ISalary {
  _id: string;
  workerId: string;
  workerName: string;
  workerSurname: string;
  salaryType: SalaryType;
  pricings: IPricing[];
  perDay: number;
  paid: number;
  debt: number;
  periodStart?: string;
  lastUpdate?: string;
  isActive: boolean;
}
